import { render } from "./SimplePhone.vue?vue&type=template&id=4d28aed2&ts=true"
import script from "./SimplePhone.vue?vue&type=script&lang=ts"
export * from "./SimplePhone.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__